import React, { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";

type RootUser = {
  email?: string | null;
  profile?: {
    first_name?: string | null;
    last_name?: string | null;
    company_name?: string | null;
    profile_photo?: string | null;
  } | null;
};

export default function Card({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const [ru, setRu] = useState<RootUser | null>(null);

  const loadLocalUser = () => {
    try {
      const raw = localStorage.getItem("roott_user");
      setRu(raw ? JSON.parse(raw) : null);
    } catch {
      setRu(null);
    }
  };

  useEffect(() => {
    loadLocalUser();
    const onProfilePhoto = () => loadLocalUser();
    window.addEventListener("roott:profile-photo-updated", onProfilePhoto);
    window.addEventListener("storage", onProfilePhoto);
    return () => {
      window.removeEventListener("roott:profile-photo-updated", onProfilePhoto);
      window.removeEventListener("storage", onProfilePhoto);
    };
  }, []);

  const displayName =
    user?.displayName ||
    user?.email?.split("@")[0] ||
    ru?.profile?.company_name ||
    "User";

  const displayEmail = user?.email || ru?.email || "—";

  const avatarUrl =
    ru?.profile?.profile_photo || (user as any)?.photoURL || null;

  return (
    <div className="w-full pb-2">
      <div className="rounded-[14px] bg-white border border-[#E2E5EA] shadow-sm">
        <div className="px-6 py-4 border-b gap-4 flex flex-col">
  <div className="font-semibold text-[20px]">Profile Information</div>

  <div className="flex items-center gap-3">
    <div className="h-11 w-11 rounded-full border border-black grid place-items-center overflow-hidden bg-white">
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt="avatar"
          className="h-full w-full object-cover"
        />
      ) : (
        <span className="material-icons text-2xl">person</span>
      )}
    </div>

    <div>
      <div className="text-base">{displayName}</div>
      <div className="text-xs text-[#8d9297]">{displayEmail}</div>
    </div>
  </div>

  {/* 👇 ADD HERE */}
  <p className="text-sm text-slate-600 leading-relaxed max-w-3xl">
    Think of this as <span className="font-medium text-slate-800">ROOTT’s knowledge base</span> about you.
    The more complete your profile, the more accurate your grant matches, AI drafts,
    and funding insights will be. Upload PDFs to give ROOTT even more context.
  </p>
</div>


        {children}
      </div>
    </div>
  );
}
